<zbp-users-table
  [roleType]="role"
  [users]="usersSubject | async"
  [schoolId]="isDistSearch ? null : schoolId"
  [isDistSearch]="isDistSearch"
  [isLoading]="isSearching"
  [noResultsMessage]="getNoResultsMessage()"
  [pageSize]="pageSize"
  [page]="page"
  [maxPageCount]="10"
  [collectionSize]="totalResults"
  (pageChange)="pageChange($event)"
  [buildActions]="buildActions"
  [rightFooterContent]="footerContent"
  (orderByParamChange)="onOrderByParamChange($event)"
></zbp-users-table>

<ng-template #footerContent>
  @if (userIsDistrictAdmin) {
    <zbp-button-component
      label="Districtwide User Settings"
      [iconName]="iconNames.cog"
      theme="ghost"
      iconSize="font-size"
      (clickHandler)="openUserSettings(true)"
    ></zbp-button-component>
  }
  @if (userIsSchoolAdmin) {
    <zbp-button-component
      label="Schoolwide User Settings"
      [iconName]="iconNames.cog"
      theme="ghost"
      iconSize="font-size"
      [disabled]="!hasSchoolIdSet"
      (clickHandler)="openUserSettings(false)"
    ></zbp-button-component>
  }
</ng-template>
<zbp-branded-fallback-download
  #exportDownload
  class="w-50 d-block ms-auto text-end"
></zbp-branded-fallback-download>

<ng-template #deleteModalBody>
  <strong>Do you want to remove this user as a {{ role }} at {{ school.name }}?</strong>
  <ul class="user-management-modal-list">
    @for (item of confirmList; track item) {
      <li>{{ item }}</li>
    }
  </ul>
</ng-template>
